export const environment = {
    production: false,
    API_ENDPOINT_APP: 'https://processor.develop.aimo-health.com/v1',
    API_ENDPOINT_SECURITY: 'https://security.develop.aimo-health.com/v1',
};
